/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Branch_Switch_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to switch branch" |
*
* @param {Chat_Branch_Switch_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_branch_switch_failed = /** @type {((inputs?: Chat_Branch_Switch_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Branch_Switch_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wechsel zur Verzweigung fehlgeschlagen")
	return /** @type {LocalizedString} */ ("Failed to switch branch")
});